import React, { lazy } from 'react';
import { MapPin, Phone, Mail, Facebook, Twitter, Youtube, Instagram } from 'lucide-react';
const quickLinks = [{
  name: 'About Us',
  href: '#about'
}, {
  name: 'Academics',
  href: '#academic'
}, {
  name: 'Admission',
  href: '#admission'
}, {
  name: 'Notice Board',
  href: '#notice'
}, {
  name: 'Gallery',
  href: '#gallery'
}, {
  name: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer id="contact" className="relative text-white bg-cover bg-center bg-no-repeat" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/u8whGdpqzXz35zTMsQzQjW/f1-bg-1.jpg)'
  }} data-id="element-89">
      <div className="absolute inset-0 bg-black/40" data-id="element-90" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-91">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-92">
          {/* Quick Links */}
          <div data-id="element-93">
            <h3 className="font-heading font-semibold text-lg mb-4" data-id="element-94">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-95">
              {quickLinks.map(link => <li key={link.name} data-id="element-96">
                  <a href={link.href} className="text-white/80 hover:text-gold transition-colors text-sm" data-id="element-97">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-98">
            <h3 className="font-heading font-semibold text-lg mb-4" data-id="element-99">
              Contact Us
            </h3>
            <ul className="space-y-3" data-id="element-100">
              <li className="flex items-start gap-3 text-sm" data-id="element-101">
                <MapPin size={18} className="text-gold mt-1 flex-shrink-0" data-id="element-102" />
                <span className="text-white/80" data-id="element-103">
                  House 10, Road 12, Gulshan-1
                  <br data-id="element-104" />
                  Dhaka-1212, Bangladesh
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm" data-id="element-105">
                <Phone size={18} className="text-gold flex-shrink-0" data-id="element-106" />
                <span className="text-white/80" data-id="element-107">+880 2 9884567</span>
              </li>
              <li className="flex items-center gap-3 text-sm" data-id="element-108">
                <Mail size={18} className="text-gold flex-shrink-0" data-id="element-109" />
                <span className="text-white/80" data-id="element-110">info@mdic.edu.bd</span>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div data-id="element-111">
            <h3 className="font-heading font-semibold text-lg mb-4" data-id="element-112">
              Follow Us
            </h3>
            <div className="flex gap-3" data-id="element-113">
              <a href="#" className="bg-white/10 hover:bg-gold p-3 rounded-full transition-colors" data-id="element-114">
                <Facebook size={20} data-id="element-115" />
              </a>
              <a href="#" className="bg-white/10 hover:bg-gold p-3 rounded-full transition-colors" data-id="element-116">
                <Twitter size={20} data-id="element-117" />
              </a>
              <a href="#" className="bg-white/10 hover:bg-gold p-3 rounded-full transition-colors" data-id="element-118">
                <Youtube size={20} data-id="element-119" />
              </a>
              <a href="#" className="bg-white/10 hover:bg-gold p-3 rounded-full transition-colors" data-id="element-120">
                <Instagram size={20} data-id="element-121" />
              </a>
            </div>
            <div className="mt-4" data-id="element-122">
              <a href="#" className="text-gold hover:text-gold/80 text-sm font-semibold transition-colors" data-id="element-123">
                Alumni Portal →
              </a>
            </div>
          </div>

          {/* Find Us */}
          <div data-id="element-124">
            <h3 className="font-heading font-semibold text-lg mb-4" data-id="element-125">Find Us</h3>
            <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-126">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.0!2d90.4125!3d23.7808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDQ2JzUxLjAiTiA5MMKwMjQnNDUuMCJF!5e0!3m2!1sen!2sbd!4v1700000000000" width="100%" height="180" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="MDIC Location" data-id="element-127"></iframe>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center text-sm text-white/70" data-id="element-128">
          <p data-id="element-129">
            © 2026 Manarat Dhaka International School & College. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}